import * as React from "react";
import { Link } from "react-router-dom";
import {
  Box,
  ButtonBase,
  Grid,
  Hidden,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import cx from "classnames";
import * as styles from "./styles.scss";
import { themeVariables } from "..";
import { SvgIcon } from "../../../../components";

export interface Tab {
  value: string;
  label: React.ReactNode;
  href?: string;
  className?: string
}

interface IProps {
  data: Array<Tab>;
  active: string;
  disabled?: boolean;
  onChange?: (val: string) => void;
}

export const BigTabs = (props: IProps) => {
  const theme = useTheme();
  const [disabled, setDisabled] = React.useState(false);

  const classes = makeStyles({
    tab: {
      border: themeVariables.borderOuter,
      backgroundColor: theme.palette.grey.A100,
      borderRadius: `${themeVariables.blockRadius}px ${themeVariables.blockRadius}px 0 0`,
      [themeVariables.breakpoints.down("sm")]: {
        border: "none",
        color: theme.palette.grey[600],
        backgroundColor: themeVariables.palette.common.white,
      },
    },
    tabActive: {
      borderBottomColor: theme.palette.background.paper,
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.grey[50],
      [themeVariables.breakpoints.down("sm")]: {
        borderBottom: "2px solid " + themeVariables.palette.primary.main,
        backgroundColor: themeVariables.palette.common.white,
        color: themeVariables.palette.common.black,
      },
    },
    button: {
      borderRadius: themeVariables.blockRadius,
      padding: `${themeVariables.spacing * 2}px ${themeVariables.spacing}px`,
      [themeVariables.breakpoints.up("sm")]: {
        paddingRight: themeVariables.spacing * 3,
        paddingLeft: themeVariables.spacing * 3,
      },
    },
    buttonActive: {
      cursor: "default",
    },
  })({});

  React.useEffect(() => {
    setTimeout(() => {
      setDisabled(props.disabled);
    }, 200);
  }, [props.disabled]);

  return (
    <Box mb="-1px" pb="1px" overflow="hidden" width="100%">
      <Grid container spacing={1} alignItems="center" wrap="nowrap">
        {props.data.map((tab) => (
          <Box clone display="flex" key={`tabs-${tab.value}-${tab.label}`}>
            <Grid item>
              <Box
                color="grey.600"
                className={cx({
                  [styles.tabWrap]: true,
                  [classes.tab]: true,
                  [classes.tabActive]: props.active === tab.value,
                })}
              >
                <ButtonBase
                  disabled={disabled}
                  onClick={
                    props.disabled ||
                    tab.value === props.active ||
                    !props.onChange
                      ? null
                      : () => {
                          props.onChange(tab.value);
                        }
                  }
                  component={tab.href ? Link : undefined}
                  to={tab.href}
                  className={cx({
                    [styles.tabButton]: true,
                    [classes.button]: true,
                    [classes.buttonActive]: props.active === tab.value,
                    [tab.className]: true
                  })}
                >
                  {tab.label}
                </ButtonBase>
               
                {/* if ((window as any)._isMobileApp) {
          tabsList.push({
            value: "poisk",
            label: <SvgIcon type="search" />,
            className: 'js-headsearch'
            // href: "/student",
          });
        } */}
               
              </Box>
            </Grid>
          </Box>
        ))}
        { (window as any)._isMobileApp &&
            <Hidden mdUp>
              <Box clone display="flex" flexGrow={"1"}>
                <Grid item justifyContent="flex-end" xs>
                  <Box
                    color="grey.600"
                    pr={2}
                    className={cx({
                      [styles.tabWrap]: true,
                      [classes.tab]: true,
                    })}
                  >
                    <ButtonBase className="js-headsearch">
                      <SvgIcon type="search" />
                    </ButtonBase>
                  </Box>
                </Grid>
              </Box>
            </Hidden>
        }
      </Grid>
    </Box>
  );
};
